import { Reveal } from "@/components/Reveal";

export default function PageHero({ eyebrow, title, subtitle, children, center = false }) {
  return (
    <section className="bg-white border-b-2 border-charcoal py-14 md:py-20">
      <div className="mx-auto max-w-5xl px-4 md:px-8">
        {children}
        <Reveal className={center ? "text-center" : undefined}>
          {eyebrow && <p className="font-heading font-semibold text-teal text-lg mt-4">{eyebrow}</p>}
          <h1 className="font-heading font-bold text-4xl md:text-6xl tracking-tight mt-1 text-charcoal">{title}</h1>
          {subtitle && <p className={`mt-4 font-body text-lg md:text-xl text-charcoal/75 max-w-2xl ${center ? "mx-auto" : ""}`}>{subtitle}</p>}
        </Reveal>
      </div>
    </section>
  );
}
